'use strict';

//Return true if user is a mobile or a tablet.
export default function isMobile(str){
  str = str||navigator.userAgent;
  return (str.match(/Tablet|iPad/i)
    || str.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i))?true:false;
}
